import { useState } from "react";
import { MdAdminPanelSettings, MdLock, MdPerson } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { apiAdminPlataforma } from "../../services/apiAdminPlataforma";

export default function AdminPlataformaLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setLoading(true);

    try {
      const response = await apiAdminPlataforma.post("/api/admin-plataforma/login/", {
        username,
        password,
      });
      const { access, refresh, user } = response.data;
      localStorage.setItem("admin_plataforma_token", access);
      localStorage.setItem("admin_plataforma_refresh", refresh);
      localStorage.setItem("admin_plataforma_user", JSON.stringify(user));
      navigate("/admin-plataforma/empresas");
    } catch (err) {
      if (!err.response) {
        setErro("Não foi possível conectar ao servidor.");
      } else {
        setErro(err.response?.data?.detail || "Credenciais inválidas.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="bg-gray-800 border border-gray-700 p-4 rounded-2xl mb-4">
            <MdAdminPanelSettings size={32} className="text-amber-500" />
          </div>
          <h1 className="text-xl font-bold text-white">Administração da Plataforma</h1>
          <p className="text-gray-400 text-sm mt-1 text-center">
            Acesso restrito à equipe Novalis Agro — não é a tela de login dos clientes.
          </p>
        </div>

        <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-xl">
          {erro && (
            <div className="mb-4 p-3 bg-red-950/50 border border-red-800 rounded-lg text-sm text-red-300">
              {erro}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide">
                Usuário
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                  <MdPerson size={18} />
                </span>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full pl-9 pr-3 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none"
                  required
                  autoFocus
                />
              </div>
            </div>

            <div className="space-y-1.5">
              <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide">
                Senha
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                  <MdLock size={18} />
                </span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-9 pr-3 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-amber-500 hover:bg-amber-600 disabled:bg-amber-800 disabled:cursor-not-allowed text-gray-900 font-semibold py-2.5 rounded-lg transition-colors text-sm"
            >
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
